class BcbsModalValue {
  static NURSE_HOTLINE = 'Insight Modal BCBS - nurse hotline';
}

class BcbsCaModalValue {
  static THERAPEUTIC_MASSAGE = 'Insight Modal BCBS-CA - therapeutic massage';

  static CHIROPRACTOR = 'Insight Modal BCBS-CA - chiropractor';

  static VITAMIX_BLENDER = 'Insight Modal BCBS-CA - vitamix blender';

  static ACUPUNCTURE = 'Insight Modal BCBS-CA - acupuncture';

  static GYM_MEMBERSHIP = 'Insight Modal BCBS-CA - gym membership';

  static FLU_SHOT = 'Insight Modal BCBS-CA - flu shot';
}

class BcbsTxModalValue {
  static GARMIN = 'Insight Modal BCBS-TX - garmin';

  static JENNY_CRAIG = 'Insight Modal BCBS-TX - jenny craig';

  static LASIK = 'Insight Modal BCBS-TX - lasik';

  static GYM_MEMBERSHIP = 'Insight Modal BCBS-TX - gym membership';

  static FLU_SHOT = 'Insight Modal BCBS-TX - flu shot';
}

class UniversalModalValue {
  static ANNUAL_WELLNESS = 'Insight Modal UNIVERSAL - annual wellness';

  static PAP = 'Insight Modal UNIVERSAL - pap smear';

  static MAMMOGRAM = 'Insight Modal UNIVERSAL - mammogram';

  static OSTEOPOROSIS = 'Insight Modal UNIVERSAL - osteoporosis';

  static COLON_CANCER_SCREENING = 'Insight Modal UNIVERSAL - colon cancer screening';

  static BREAST_PUMP = 'Insight Modal UNIVERSAL - breast pump';
}

class AetnaModalValue {
  static NURSE_HOTLINE = 'Insight Modal AETNA - nurse hotline';

  static FLU_SHOT = 'Insight Modal AETNA - flu shot';

  static GYM_MEMBERSHIP = 'Insight Modal AETNA - gym membership';

  static CHIROPRACTOR = 'Insight Modal AETNA - chiropractor';

  static ACUPUNCTURE = 'Insight Modal AETNA - acupuncture';

  static APPAREL = 'Insight Modal AETNA - apparel';

  static THERAPEUTIC_MASSAGE = 'Insight Modal AETNA - therapeutic massage';

  static LASIK = 'Insight Modal AETNA - lasik';
}

class CignaModalValue {
  static FLU_SHOT = 'Insight Modal CIGNA - flu shot';

  static GYM_MEMBERSHIP = 'Insight Modal CIGNA - gym membership';

  static THERAPEUTIC_MASSAGE = 'Insight Modal CIGNA - therapeutic massage';

  static CHIROPRACTOR = 'Insight Modal CIGNA - chiropractor';

  static PHYSICAL_THERAPY = 'Insight Modal CIGNA - physical therapy';

  static JENNY_CRAIG = 'Insight Modal CIGNA - jenny craig';

  static GAIAM_YOGA = 'Insight Modal CIGNA - gaiam yoga';

  static ACUPUNCTURE = 'Insight Modal CIGNA - acupuncture';

  static GLASSES = 'Insight Modal CIGNA - glasses';

  static LASIK = 'Insight Modal CIGNA - lasik';
}

class UnitedModalValue {
  static NURSE_HOTLINE = 'Insight Modal UNITED - nurse hotline';

  static FLU_SHOT = 'Insight Modal UNITED - flu shot';

  static GYM_MEMBERSHIP = 'Insight Modal UNITED - gym membership';

  static LASIK = 'Insight Modal UNITED - lasik';

  static QUIT_FOR_LIFE = 'Insight Modal UNITED - quit for life';
}

export {
  AetnaModalValue,
  CignaModalValue,
  UnitedModalValue,
  BcbsModalValue,
  BcbsCaModalValue,
  BcbsTxModalValue,
  UniversalModalValue,
};
